import Form from '@components/dataEntry/form';
import FullInput from '@components/dataEntry/FullInput';
import Button from '@components/general/button';
import { ArrowLeftIcon, MailIcon } from '@heroicons/react/outline';
import { yupResolver } from '@hookform/resolvers/yup';
import { toastNotification } from '@hooks/toast-notification';
import { useMutationSideEffects } from '@hooks/use-mutation-side-effect';
import useRequest from '@services/api';
import { removeNullValues } from '@utils/remove-null-values';

import SimpleLayout from 'layout/SimpleLayout';
import { useRouter } from 'next/router';
import { useState } from 'react';
import { useForm } from 'react-hook-form';
import * as yup from 'yup';

const ForgotPassword = () => {
  const { push } = useRouter();
  const [errorsServerValidation, setErrorsServerValidation] = useState({});
  const { mutateAsync: forgotPassword } = useRequest.user.forgotPassword();

  const defaultValues = {
    email: ''
  };

  const validationSchema = yup.object({
    email: yup.string().email('Invalid email format').required('Email is a required field')
  });

  // actions
  const { handleSubmit, formId, loading } = useMutationSideEffects({
    setErrorsServerValidation,
    showToastMessage: false,
    onSubmit: async (inputs) => {
      await forgotPassword(inputs, {
        onSuccess: (data) => {
          toastNotification({
            type: 'success',
            description: data.data.message
          });
          push('/sign-in');
        },
        onError: (err: Error) => {
          const errors = err.response.data.errors;
          setErrorsServerValidation(errors);
        }
      });
    }
  });

  const LeftIcon = () => (
    <div className="pointer-events-none absolute inset-y-0 left-0 flex items-center pl-3">
      <MailIcon className="text-primary-grey-300 w-4 h-4" />
    </div>
  );

  const inputs = [
    {
      name: 'email',
      label: 'Email Address',
      inputClass: 'mt-2 pl-10',
      placeholder: 'Enter your email',
      type: 'text',
      IconProps: {
        LeftIcon: () => <LeftIcon />
      }
    }
  ];

  const methods = useForm({
    defaultValues: removeNullValues(defaultValues),
    resolver: validationSchema ? yupResolver(validationSchema) : null
  });

  return (
    <div className="flex h-[85vh] justify-center items-center">
      <div className="flex min-h-full w-96 flex-col justify-center">
        <div className="mb-2">
          <h2 className="mt-6 text-center text-2xl tracking-tight text-primary-navy-500">
            Forgot password?
          </h2>
          <p className="mt-2 text-center text-sm text-primary-grey-500">
            No worries! We'll send you reset instructions
          </p>
        </div>

        <div className="sm:mx-auto w-full">
          <div>
            <Form
              methods={methods}
              errorsServerValidation={errorsServerValidation}
              onEnterSubmit
              onSubmit={handleSubmit}
              formId={formId}
            >
              {inputs.map((data, index) => (
                <FullInput key={index} {...data} />
              ))}
              <Button
                type="submit"
                disabled={loading}
                variant="primary"
                loading={loading}
                className="w-full justify-center mt-4"
                size="lg"
              >
                Reset Password
              </Button>
            </Form>
          </div>
        </div>

        <div className="flex flex-col items-center justify-center mt-2">
          <Button
            className="text-primary-grey-500 text-xs"
            onClick={() => push('/sign-in')}
            icon={<ArrowLeftIcon className="text-primary-grey-300 w-4 h-4" />}
          >
            Back to login
          </Button>
        </div>
      </div>
    </div>
  );
};

export default ForgotPassword;

ForgotPassword.WithoutAuth = true;
ForgotPassword.PageLayoutContainer = SimpleLayout;
